<ng-container *ngIf="loggedInUserRole === 'Employee'; else editVariablePay">
    <div>
      <ion-row>
        <ion-col size-sm="3" size-md="3" size-lg="10" size-xs="3">
          <div class="formLabelSemiBoldfs14 ml-10 mt-10">Variable Pay Letter 
          </div>
        </ion-col>
        <ion-col size-sm="3" size-md="3" size-lg="1" size-xs="3">
          <button class="download-btn mt-10">
            <span class="ml-5 fs-12 material-icons">arrow_downward</span>
            download
          </button>
        </ion-col>

        <ion-col size-sm="3" size-md="3" size-lg="1" size-xs="3">
          <div class="close_bg close-button mt-10" [mat-dialog-close]>
            <img src="././assets/icon/close_icon.png" class="closeHeight">
          </div>
        </ion-col>
      </ion-row>

      <div class="modal-body p-10">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="variable-pay-container">
              <div class="main-container">
                <div class="variable-pay-gradient">
                </div>
                  <ion-row>
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="variable-pay-content">
                        <div class="variable-pay-section">
                          <div class="company-logo">
                            <img src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg" alt="company-logo" />
                          </div>
                        </div>
                        <div class="border-bottom"></div>
                      </div>
                    </ion-col>
          
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <!-- <div class="cardBox"> -->
                        <div class="variable-pay-content">
                          <p>
                            Date: [DD/MM/YYYY],
                          </p>
                          <br />
                          <p>To,</p>
                          <br />
                          <p>
                            [Employee's Name]
                          </p>
                          <p>
                            [Employee's Designation]
                          </p>
                          <p>
                            [Department]
                          </p>
                          <p>
                            [Employee's office location]
                          </p>
                          <p>
                            Subject: Salary Increment Notification
                          </p>
                          <br />
                          <p>
                            Dear [Employee's Name],
                          </p>
                          <br />
                          <p>
                            Basis your annual performance for the year 23-24, you have been awarded a performance rating of
                            [rating]
                            and we are pleased to inform you basis your band, your effective all inclusive increment %ge is
                            [Increment %ge].
                            This increment reflects your hard work, dedication, and the significant contributions you have made to
                            the company.
                            Your revised annual CTC post increment is [New annual CTC Amount].
                          </p>
                          <p>
                            Promotion content: We are also delighted to inform that you have been promoted wef
                            1st April 2024 and your new designation is [revised designation].
                          </p>
                          <p>
                            Please note that the revised salary will be effective from 1st Pril 2024 and will reflect in your
                            payslip.
                          </p>
                          <p>
                            We appreciate your continued efforts and dedication to your role. If you have any questions or require
                            further clarification regarding this increment,
                            please feel free to reach out to the HR department.
                          </p>
                          <p>
                            Congratulations!!
                          </p>
                          <br />
                          <p>Sincerely,</p>
                          <p>Digital Signature</p>
                          <p>Name of Head HR</p>
                          <p>Designation</p>
                          <br />
                          <div class="border-bottom"></div>
                        </div>
                      <!-- </div> -->
                    </ion-col>
          
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                      <div class="variable-pay-letter-footer">
                        <div>
                          <span class="material-icons fs-16 mr-5">call</span>91 0000000000
                        </div>
                      </div>
                    </ion-col>
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                      <div class="variable-pay-letter-footer">
                        <div>
                          <span class="material-icons fs-16 mr-5">language</span>www.companyname.com
                        </div>
                      </div>
                    </ion-col>
                    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                      <div class="variable-pay-letter-footer">
                        <div>
                          <span class="material-icons fs-16 mr-5">mail</span>info&#64;companyname.com
                        </div>
                      </div>
                    </ion-col>
          
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="variable-pay-letter-footer">
                        <div>
                          <span class="material-icons fs-16 mr-5">location_on</span>Registered Address:
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                <div class="variable-pay-gradient">
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
</ng-container>

<ng-template #editVariablePay>
  <div>
    <ion-row>
      <ion-col size-sm="3" size-md="3" size-lg="10" size-xs="3">
        <div class="formLabelSemiBoldfs14 ml-10 mt-10">Variable Pay Letter
        </div>
      </ion-col>
      <ion-col size-sm="3" size-md="3" size-lg="2" size-xs="3">
        <div class="close_bg close-button mt-10" [mat-dialog-close]>
          <img src="././assets/icon/close_icon.png" class="closeHeight">
        </div>
      </ion-col>
    </ion-row>
  
    <div class="modal-body p-10">
      <ion-row>
        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
          <div class="input-form">
            <p>Subject:</p>
            <mat-form-field class="w-100 mat-height40 pl-15 mat-input-style">
              <input matInput placeholder="Type here" [(ngModel)]="vpPolicyUrlSubject">
            </mat-form-field>
          </div>
        </ion-col>
  
        <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
          <div class="variable-edit-buttons">
            <div class="btn-discard">
              <button (click)="onClickDiscardChanges()">Discard Changes</button>
            </div>
  
            <div class="btn-save">
              <button (click)="saveVPPolicyFile()">Save</button>
            </div>
          </div>
        </ion-col>
      </ion-row>
  
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <angular-editor [placeholder]="'Enter Email here...'" [config]="editorConfig"
            [(ngModel)]="vpletterContent"></angular-editor>
        </ion-col>
      </ion-row>
    </div>
  </div>
</ng-template>
